module.exports = new __parcel__URL__("Key_Technologies_1.4af6d7fc.jpg").toString();